import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileCallBar from "@/components/MobileCallBar";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  const isAdmin = pathname.startsWith("/admin");

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="site-layout">
      {!isAdmin && <Navbar />}
      <main className={`flex-1 ${!isAdmin ? "pb-14 lg:pb-0" : ""}`}>
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <MobileCallBar />}
    </div>
  );
}
